import { defineStore, acceptHMRUpdate } from "pinia";
import type { TourType, Destination, Tour, Testimony } from "~/types/general";

export const useTourStore = defineStore({
  id: "tours",
  state: () => ({
    tours: [] as Tour[],
    tourType: [] as TourType[],
    destinations: [] as Destination[],
    testimony: [] as Testimony[],
  }),

  getters: {
    getTours(): Tour[] {
      return this.tours;
    },

    getTourTypes(): TourType[] {
      return this.tourType;
    },

    getDestinations(): Destination[] {
      return this.destinations;
    },

    getTourBySlug: (state) => (slug: string) => {
      return state.tours.find((tour: Tour) => tour.slug === slug);
    },
    getTestimony(): Testimony[] {
      return this.testimony;
    },
  },

  actions: {
    async fetchTourTypes() {
      // Reference: https://github.com/nuxt/nuxt/issues/13805
      const fetch = useFetch<{ data: TourType[] }>(
        import.meta.env.VITE_BASE_API_URL + "tour-types",
        {
          onRequest: ({ request, options }) => {
            // console.log("Request:", request);
          },
          onResponse: ({ response }) => {
            this.tourType = response._data;
          },
        },
      );

      await fetch.execute({ _initial: true });

      // if (fetch.data.value) {
      // fetch using Nuxt Server
      // const data = await $fetch("/api/tour-types");
      // if (true) {
      //    // ignore the error for now
      //    // @ts-ignore: FIXME: resolve TS: Object is possibly 'undefined'.
      //    this.tourType = data;
      // }
    },

    async fetchTours() {
      const fetch = useFetch<{ data: Tour[] }>(
        import.meta.env.VITE_BASE_API_URL + "tours",
        {
          onRequest: ({ request, options }) => {},
          onResponse: ({ response }) => {
            this.tours = response._data;
          },
        },
      );

      await fetch.execute({ _initial: true });
    },

    async fetchDestinations() {
      const fetch = useFetch<{ data: Destination[] }>(
        import.meta.env.VITE_BASE_API_URL + "destinations",
        {
          onRequest: ({ request, options }) => {},
          onResponse: ({ response }) => {
            this.destinations = response._data;
          },
        },
      );

      await fetch.execute({ _initial: true });
    },

    async getTourTestionies(tourId: number) {
      const fetch = useFetch<{ data: Testimony[] }>(
        import.meta.env.VITE_BASE_API_URL + `tour/${tourId}/testimonies`,
        {
          onRequest: ({ request, options }) => {},
          onResponse: ({ response }) => {
            this.testimony = response._data;
          },
        },
      );

      await fetch.execute({ _initial: true });
    },
  },
});

if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(
    acceptHMRUpdate(useTourStore, (import.meta as any).hot),
  );
}
